import { Link } from "react-router-dom";
import { Video, Building2, BadgeCheck } from "lucide-react";
import { Kicker, Reveal } from "../components/Reveal";
import { IMAGES } from "../lib/data";

const POINTS = [
  { icon: Building2, text: "New patients — in-person evaluation at Salon 406, North Ogden" },
  { icon: Video, text: "Renewals — convenient telehealth visits from anywhere in Utah" },
  { icon: BadgeCheck, text: "Certified by Nichole Olsen, a licensed Utah Nurse Practitioner" },
];

export default function CannabisSection() {
  return (
    <section id="cannabis" data-testid="cannabis-section" className="bg-forest py-20 text-ivory sm:py-28">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 sm:px-8 lg:grid-cols-2">
        <Reveal>
          <Kicker className="text-gold">Now Offering</Kicker>
          <h2 className="mt-4 font-serif text-4xl font-medium leading-tight tracking-tight sm:text-5xl">
            Utah Medical Cannabis Cards
          </h2>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-ivory/80">
            Nichole is a registered Qualified Medical Provider and can certify
            your Utah Medical Cannabis Card. New certifications happen in
            person; renewals are handled easily over telehealth.
          </p>

          <ul className="mt-8 space-y-4">
            {POINTS.map((p) => (
              <li key={p.text} className="flex items-start gap-4">
                <p.icon size={18} className="mt-0.5 shrink-0 text-gold" />
                <span className="text-sm leading-relaxed text-ivory/85">{p.text}</span>
              </li>
            ))}
          </ul>

          <p className="mt-8 text-sm text-ivory/70">
            <span className="font-serif text-2xl text-ivory">$125</span> new patient
            <span className="mx-3">&middot;</span>
            <span className="font-serif text-2xl text-ivory">$75</span> renewal
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              to="/book?service=cannabis-new"
              data-testid="cannabis-book-new"
              className="rounded-md bg-ivory px-7 py-3.5 text-sm font-semibold text-forest transition-colors duration-300 hover:bg-cream"
            >
              Book Your Evaluation
            </Link>
            <Link
              to="/book?service=cannabis-renewal"
              data-testid="cannabis-book-renewal"
              className="rounded-md border border-ivory/40 px-7 py-3.5 text-sm font-semibold text-ivory transition-colors duration-300 hover:border-ivory"
            >
              Renew by Telehealth
            </Link>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mx-auto max-w-md overflow-hidden rounded-lg">
            <img
              src={IMAGES.cannabis}
              alt="Green medical cross — Utah medical cannabis program"
              className="h-[460px] w-full object-cover"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
